import React from 'react';

// Honest placeholder for features that are planned but not yet functional.
export default function ComingSoon({ title = 'This feature', note }) {
  return (
    <div style={{ padding: '64px 40px', maxWidth: 640, margin: '0 auto', textAlign: 'center', fontFamily: "'Outfit', 'DM Sans', sans-serif" }}>
      <div style={{ width: 64, height: 64, borderRadius: 16, margin: '0 auto 20px', display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: 'linear-gradient(135deg, #7c3aed12, #a855f712)', color: '#7c3aed' }}>
        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
      </div>
      <h1 style={{ fontSize: 24, fontWeight: 700, color: '#111827', margin: '0 0 8px' }}>{title} — coming soon</h1>
      <p style={{ fontSize: 14, color: '#9ca3af', margin: 0, lineHeight: 1.7 }}>
        {note || "We're building this properly. It'll be here soon — we'd rather ship it right than ship it half-working."}
      </p>
    </div>
  );
}
